import config from '../../config';

const sendMessage = async (msgProvider, contactNo, message, file, fileUrl, msgEndpoint, leadId) => {
  let errMessage = '';
  let successMessage = '';
  const formdata = new FormData();
  formdata.append('provider', msgProvider);
  formdata.append('message', message);
  formdata.append('phoneNumber', contactNo);
  if (leadId) {
    formdata.append('leadId', leadId);
  }
  if (file) {
    formdata.append('file', file);
  } else if (fileUrl) {
    formdata.append('fileUrl', fileUrl);
  }
  try {
    const response = await fetch(msgEndpoint?.endpoint || config.messageServer.url, {
      method: 'POST',
      body: formdata,
    });
    const respMsg = await response.text();
    if (response.ok) {
      successMessage = respMsg;
    } else {
      errMessage = respMsg;
    }
  } catch (e) {
    errMessage = e.message === 'Failed to fetch' ? 'Message server is not running' : e.message;
  }
  return { errMessage, successMessage };
};

/**
 * Send a contract link to the lead.
 *
 * @param {Object} sendData - The data to send, including the message provider, text and lead information.
 * @param {firebase.remote.RemoteType} remote - The Firebase remote object for Firebase-related operations.
 * @returns {Promise<boolean>} Resolves with a boolean indicating whether the operation was successful.
 */
const sendContract = async (sendData, remote) => {
  const response = await remote('sendLeadContractLink', sendData);

  if (!response.ok) {
    throw new Error(`Error occurred while sending the contract to lead via ${sendData.msgProvider}`);
  }

  return response.ok;
};

export {
  sendMessage,
  sendContract,
};
